var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute bg-crm-2 w-3 h-3 rounded-full hidden xxs:block",style:({ left: _vm.left, right: _vm.right, top: _vm.top, bottom: _vm.bottom })})}
var staticRenderFns = []

export { render, staticRenderFns }